"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactFormPopupContent = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const forms_service_ui_1 = require("@danfoss/forms-service-ui");
const forms_service_ui_webex_1 = require("@danfoss/forms-service-ui-webex");
const app_1 = require("app");
const React = require("react");
const webexUI_1 = require("webexUI");
const ContactFormAnalyticsService_1 = require("./ContactFormAnalyticsService");
require("@danfoss/mosaic/css/mosaic.css");
class ContactFormPopupContent extends React.Component {
    constructor() {
        super(...arguments);
        this.contactFormPopupRef = React.createRef();
        this.needsGeneralContentFocus = true;
        this.getMessage = (dictionaryValue, error) => {
            return error ? ((0, jsx_runtime_1.jsx)("p", { children: dictionaryValue.submitErrorMessage })) : ((0, jsx_runtime_1.jsx)("span", { children: (0, app_1.StringToHTML)(dictionaryValue.submitSuccessMessage) }));
        };
        this.hideSpinner = () => {
            this.props.setFormState({ isSpinnerVisible: false });
        };
        this.onFieldClick = (_event, field) => {
            const { formAlias, formTitle } = this.props;
            const { type, url } = field;
            if (type === 'LinkButton') {
                ContactFormAnalyticsService_1.ContactFormAnalyticsService.trackServiceProcessesRedirect(formAlias, formTitle, url);
            }
        };
        this.onFormSubmit = () => {
            const { formAlias, formTitle } = this.props;
            this.needsGeneralContentFocus = false;
            ContactFormAnalyticsService_1.ContactFormAnalyticsService.trackFormSubmit(formAlias, formTitle);
        };
        this.onValidationError = (errors, isBackend) => {
            const { formAlias, formTitle } = this.props;
            this.needsGeneralContentFocus = false;
            ContactFormAnalyticsService_1.ContactFormAnalyticsService.trackValidationErrors(formAlias, formTitle, errors, isBackend);
        };
        this.onGenericError = () => {
            const { formAlias, formTitle } = this.props;
            this.needsGeneralContentFocus = true;
            this.props.setFormState({ submitted: true, error: true });
            ContactFormAnalyticsService_1.ContactFormAnalyticsService.trackGenericFormError(formAlias, formTitle);
        };
        this.onSuccess = () => {
            const { formAlias, formTitle } = this.props;
            this.needsGeneralContentFocus = true;
            this.props.setFormState({ submitted: true, error: false });
            ContactFormAnalyticsService_1.ContactFormAnalyticsService.trackFormSubmitSuccess(formAlias, formTitle);
        };
        this.onLoadFailed = () => {
            const { contactData } = this.props;
            this.needsGeneralContentFocus = true;
            this.props.setFormState({ formLoadFailed: true, isSpinnerVisible: false });
            ContactFormAnalyticsService_1.ContactFormAnalyticsService.trackFormLoadError(contactData.companyName);
        };
    }
    componentDidMount() {
        this.contactFormPopupRef.current.focus();
    }
    componentDidUpdate() {
        if (this.needsGeneralContentFocus) {
            this.contactFormPopupRef.current.focus();
        }
    }
    render() {
        const { formAlias, contactData, dictionary, companyName, culture, formServiceUrl, contactFormState, } = this.props;
        const { isSpinnerVisible, submitted, formLoadFailed, error } = contactFormState;
        const hasFormResult = submitted || formLoadFailed;
        const isIE = app_1.PageService.browserType === app_1.browserTypes.ie;
        if (isIE) {
            return ((0, jsx_runtime_1.jsx)("div", { className: "contact-form-popup__content", tabIndex: -1, "aria-live": hasFormResult ? 'assertive' : 'off', ref: this.contactFormPopupRef, children: (0, jsx_runtime_1.jsx)("p", { children: dictionary.browserNotSupported }) }));
        }
        return ((0, jsx_runtime_1.jsxs)("div", { className: "contact-form-popup__content", tabIndex: -1, "aria-live": hasFormResult ? 'assertive' : 'off', ref: this.contactFormPopupRef, children: [isSpinnerVisible && ((0, jsx_runtime_1.jsx)("div", { className: "contact-form-popup__spinner-wrapper", children: (0, jsx_runtime_1.jsx)(webexUI_1.Spinner, { visible: true }) })), !submitted ? ((0, jsx_runtime_1.jsx)(forms_service_ui_1.Form, { fieldComponentMap: forms_service_ui_webex_1.fieldComponentMap, culture: culture, formAlias: formAlias, apiDomain: formServiceUrl, onFieldClick: this.onFieldClick, onFormLoadSuccess: this.hideSpinner, onFormSubmit: this.onFormSubmit, onValidationError: this.onValidationError, additionalFormData: {
                        contactId: contactData.id,
                        contactName: companyName,
                    }, onSuccess: this.onSuccess, onGenericError: this.onGenericError, onFormLoadFailure: this.onLoadFailed, isPopup: true })) : ((0, jsx_runtime_1.jsx)("div", { className: "contact-form-popup__submit-result", children: this.getMessage(dictionary, error) })), formLoadFailed && (0, jsx_runtime_1.jsx)("p", { children: dictionary.genericErrorMessage })] }));
    }
}
exports.ContactFormPopupContent = ContactFormPopupContent;
